import axios from 'axios';
import { Cookies } from 'react-cookie';
import { atom, selector } from 'recoil';
import { URL_FOUNDATION } from '../config/keys';
import { AtomCategory, AtomState } from './utils/model/Model';

export type Product = {
	id: number
	uuid: string,
	name: string,
	brand?: number,
	category?: number,
	tags: number[],
	price?: number,
	barcode?: string,
	code_upc?: string,
	reference?: string,
	outer?: number,
	width?: number,
	height?: number,
	depth?: number,
	photos_url?: string[]
}

// -----------------------[ ATOM ]----------------------- //
const AProductsAtom = atom({
	key: 'AProductsAtom', // UNIQUE ID
	default: getProducts()
});

export const AProducts = selector<Product[]>({
	key: 'AProducts',
	get: ({ get }) => get(AProductsAtom),
	set: ({ set }, newValue) => set(AProductsAtom, newValue)
});

const AGlobalMapProductUuid: AtomState<string> = {
	category: AtomCategory.GLOBAL,
	atom: atom({
		key: 'atom_global_map_product_uuid', // UNIQUE ID
		default: localStorage.getItem('selected_map_product_uuid') ?? ''
	})
};

export const AMapProductUuid = selector<string>({
	key: 'AMapProductUuid',
	get: ({ get }) => get(AGlobalMapProductUuid.atom),
	set: ({ set }, newValue) => {
		localStorage.setItem('selected_map_product_uuid', newValue.toString());
		return set(AGlobalMapProductUuid.atom, newValue);
	}
});

// The product whose value colors the map on a per-product calculated field:
// the picked one, or the first by name until the user picks
export const AMapProduct = selector<Product | undefined>({
	key: 'AMapProduct',
	get: ({ get }) => {
		const products = get(AProducts);
		const uuid = get(AMapProductUuid);
		return products.find(p => p.uuid === uuid)
			?? [...products].sort((a, b) => a.name.toLocaleLowerCase().localeCompare(b.name.toLocaleLowerCase()))[0];
	}
});

// -----------------------[ API ]------------------------ //
const cookies = new Cookies();
const token: string | null = cookies.get('id_token') || null;

axios.defaults.headers.common.Authorization = `${token ?? ''}`;

export async function getProducts(): Promise<Product[]> {
	try {
		return await axios({
			method: 'get',
			url: `${URL_FOUNDATION}/api/v2/products/all`
		}).then(res => res.data);
	} catch (e) {
		console.error(e);
		return [];
	}
}

export async function getDeletedProducts(): Promise<Product[]> {
	try {
		return await axios({
			method: 'get',
			url: `${URL_FOUNDATION}/api/v2/products/deleted`
		}).then(res => res.data);
	} catch (e) {
		console.error(e);
		return [];
	}
}
